import request from '@/router/axios';
// 租后逾期总览
export const getOverdueCustomerData = params => {
  return request({
    url: `/api/v2/blade-loanPost/loan/getOverdueCustomerData`,
    method: 'post',
    data: {
      ...params,
    },
  });
};

// 法务每月数据统计
export const proceedingCount = params => {
  return request({
    url: `/api/blade-legalManagement/legalManagement/proceedingCount`,
    method: 'post',
    data: {
      ...params,
    },
  });
};

// 维护当月数据统计
export const monthCount = params => {
  return request({
    url: `/api/v2/blade-loanPost/loan/monthCount`,
    method: 'post',
    data: {
      ...params,
    },
  });
};

// 谈判当月数据统计
export const getNegotiationMonthStatistics = params => {
  return request({
    url: `/api/v2/blade-loanPost/loan/getNegotiationMonthStatistics`,
    method: 'post',
    data: {
      ...params,
    },
  });
};

// 行动当月数据统计
export const trailer = params => {
  return request({
    url: `/api/blade-trailerStatistics/trailerStatistics/trailer`,
    method: 'post',
    data: {
      ...params,
    },
  });
};

// 代偿每月数据统计
export const customerCompensationCount = params => {
  return request({
    url: `/api/blade-compensation/compensationManagement/customerCompensationCount`,
    method: 'post',
    data: {
      ...params,
    },
  });
};
// 租后月数据统计
export const getCount = params => {
  return request({
    url: `/api/blade-loanCustomerCollectionStatistics/loanCustomerCollectionStatistics/getCount`,
    method: 'post',
    data: {
      ...params,
    },
  });
};

